import { PremiumFeature } from 'gleblu-socket-api';
import { createAction } from 'redux-act';

import TimestampPayload from '../TimestampPayload';

export interface SubscriptionCreatedPayload extends TimestampPayload {
  placeUuid: string;
  feature: PremiumFeature;
}
export const subscriptionCreated = createAction<SubscriptionCreatedPayload>('SUBSCRIPTION_CREATED');
